import { useEffect, useState } from 'react';
import { GalleryItem, GalleryNotFoundError, loadGalleryItem } from '../data/gallery';

export const useGalleryItem = (slug?: string) => {
  const [item, setItem] = useState<GalleryItem | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) {
      setItem(null);
      setNotFound(false);
      setError(null);
      return;
    }

    let isCancelled = false;

    const fetchItem = async () => {
      try {
        setLoading(true);
        setNotFound(false);
        const data = await loadGalleryItem(slug);
        if (!isCancelled) {
          setItem(data);
          setError(null);
        }
      } catch (err) {
        if (!isCancelled) {
          if (err instanceof GalleryNotFoundError) {
            setNotFound(true);
            setError(null);
          } else {
            setError(err as Error);
          }
          setItem(null);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    fetchItem();

    return () => {
      isCancelled = true;
    };
  }, [slug]);

  return { item, loading, error, notFound };
};
